import React from 'react';
export function CourseGoal() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2330">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2331">
        <div className="mb-12" data-id="element-2332">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2333">
            Course Goal
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2334">
            <p className="text-base text-gray-800 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2335">
              To develop in the students the knowledge, skills and attitude
              essential for avoiding dangerous confrontations and for the safe,
              effective, and responsible use of a concealed handgun for
              self-defense outside the home.
            </p>
          </div>
        </div>
      </div>
    </div>;
}